var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "邮件ID：",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.email_id) + " ")]), _c("el-form-item", {
    attrs: {
      label: "申请原因：",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.email_content) + " ")]), _vm.openEmailType === 1 ? _c("el-form-item", {
    staticStyle: {
      color: "#409EFF"
    },
    attrs: {
      label: "服务器列表：",
      "label-width": "150px"
    }
  }, [_vm._v(" 服务器ID: "), _c("span", {
    staticStyle: {
      color: "#67c23a"
    }
  }, [_vm._v(_vm._s(_vm.formData.server_id) + " ")]), _vm._v(" 服务器名： "), _c("span", {
    staticStyle: {
      color: "#67c23a"
    }
  }, [_vm._v(_vm._s(_vm.serverList[_vm.formData.server_id]))])]) : _vm._e(), _vm.openEmailType === 2 ? _c("el-form-item", {
    attrs: {
      label: "服务器列表：",
      "label-width": "150px"
    }
  }, _vm._l(_vm.formData.server_id_list, function (item, i) {
    return _c("div", {
      key: i,
      staticStyle: {
        color: "#409EFF"
      }
    }, [_vm._v(" 服务器ID: "), _c("span", {
      staticStyle: {
        color: "#67c23a"
      }
    }, [_vm._v(_vm._s(item))]), _vm._v(" 服务器名： "), _c("span", {
      staticStyle: {
        color: "#67c23a"
      }
    }, [_vm._v(_vm._s(_vm.serverList[item]))])]);
  }), 0) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: _vm.openEmailType == 1 ? " 已读邮件后保留至时间：" : "邮件发送截至时间：",
      "label-width": "200px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.expire) + " ")]), _vm.openEmailType === 1 ? _c("el-form-item", {
    attrs: {
      label: "角色类型：",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.role_type == 1 ? "角色ID" : "角色名") + " ")]) : _vm._e(), _vm.formData.role_list ? _c("el-form-item", {
    attrs: {
      label: _vm.openEmailType === 1 ? "角色ID：" : "角色名：",
      "label-width": "150px"
    }
  }, _vm._l(_vm.formData.role_info_map, function (item, index) {
    return _c("div", {
      key: index,
      staticStyle: {
        color: "#409EFF"
      }
    }, [_vm._v(" 角色ID： "), _c("span", {
      staticStyle: {
        color: "#67c23a"
      }
    }, [_vm._v(" " + _vm._s(item.roleId) + " ")]), _vm._v(" 角色名称： "), _c("span", {
      staticStyle: {
        color: "#67c23a"
      }
    }, [_vm._v(_vm._s(item.roleName))])]);
  }), 0) : _vm._e(), _vm.openEmailType === 2 && _vm.formData.condition && _vm.formData.condition[0].login_time_range ? _c("el-form-item", {
    attrs: {
      label: "角色登录时间段：",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.condition[0].login_time_range.sdate) + " - " + _vm._s(_vm.formData.condition[0].login_time_range.edate) + " ")]) : _vm._e(), _vm.openEmailType === 2 && _vm.formData.condition && _vm.formData.condition[0].create_time_range ? _c("el-form-item", {
    attrs: {
      label: "角色创建时间：",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.condition[0].create_time_range.sdate) + " - " + _vm._s(_vm.formData.condition[0].create_time_range.edate) + " ")]) : _vm._e(), _vm.openEmailType === 2 && _vm.formData.condition && _vm.formData.condition[0].role_level_range ? _c("el-form-item", {
    attrs: {
      label: "角色等级：",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.condition[0].role_level_range.min) + "级 - " + _vm._s(_vm.formData.condition[0].role_level_range.max) + "级 ")]) : _vm._e(), _vm.openEmailType === 2 && _vm.formData.condition && _vm.formData.condition[0].pay_amount_range ? _c("el-form-item", {
    attrs: {
      label: "充值金额：",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.condition[0].pay_amount_range.min) + "元 - " + _vm._s(_vm.formData.condition[0].pay_amount_range.max) + "元 ")]) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "邮件物品：",
      "label-width": "150px"
    }
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.formData.item_list,
      "header-row-style": _vm.headStyle,
      "row-style": _vm.rowStyle
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "item_id",
      label: "物品ID",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "物品名",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.goodList[scope.row.item_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "num",
      label: "数量",
      "min-width": "150"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "申请人用户名",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.UserInfoList[_vm.formData.apply_id]) + " ")]), _c("el-form-item", {
    attrs: {
      label: "审批人用户名",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.UserInfoList[_vm.formData.approve_id]) + " ")])], 1)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };